$(document).ready(function() {
	const currency = $(this).attr('data-currency');
	$('.mortgage-calculator').validate({
		submitHandler: function(form) {
			JSRedo();
			return false;
		},
		rules: {
			MonthlyIncome: {
				required: true,
				number: true,
				range: [0.01, 999999999]
			},
			Joint: {
				number: true,
				range: [0.00, 999999999]
			},
			Debt: {
				number: true,
				range: [0.00, 999999999]
			},
			Rate: {
				required: true,
				number: true,
				range: [0.00, 99]
			},
			Term: {
				required: true,
				number: true,
				range: [1, 30]
			}
		},
		messages: {
			MonthlyIncome: {
				required: "Please enter a number in this field",
				number: "Please enter only numbers in this field",
				range: "Please enter an number between " + currency + "0.00 and $999,999,999"
			},
			Joint: {
				number: "Please enter only numbers in this field",
				range: "Please enter an number between $0.00 and $999,999,999"
			},
			Debt: {
				number: "Please enter only numbers in this field",
				range: "Please enter a number between $0.00 and $999,999,999"
			},
			Rate: {
				required: "Please enter a number in this field",
				number: "Please enter only numbers in this field",
				range: "Please enter an number between 0.00 and 99.00"
			},
			Term: {
				required: "Please enter a number in this field",
				number: "Please enter only numbers in this field",
				range: "Please enter a number between 1 and 30"
			}
		}
	});
});
